import { useMemo } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import Modal from '../../Atoms/Modal';
import { RawHtml } from '../../Utilities';

const TaxonomyModal = ({ isOpen, onClose, groups, activeSlug }) => {
  const activeItem = useMemo(() => {
    if (!activeSlug || !groups?.length) return null;
    for (const group of groups) {
      const found = group.items?.find((item) => item.slug === activeSlug);
      if (found) return found;
    }
    return null;
  }, [activeSlug, groups]);

  const colorStyle = activeItem?.color ? {
    '--item-color':  activeItem.color,
    '--item-bg':     `${activeItem.color}0d`,
    '--item-border': `${activeItem.color}30`,
  } : {};

  const modalTitle = (
    <div className="text-block-title">{activeItem?.name || 'Topic'}</div>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
      title={modalTitle}
    >
      {!activeItem && (
        <div className="text-body text-muted">No information found.</div>
      )}

      {activeItem && (
        <div
          className="taxonomy-item"
          style={colorStyle}
        >
          {activeItem.icon && (
            <div className="taxonomy-item__header">
              <span className="taxonomy-item__icon" aria-hidden="true">
                {activeItem.icon}
              </span>
            </div>
          )}

          {activeItem.description && (
            <RawHtml html={activeItem.description} className="text-body-sm text-muted" />
            )}

          {activeItem.hub_page_url && (
            <div className="taxonomy-item__footer">
              <Link href={activeItem.hub_page_url} className="base-link text-body-sm">
                Explore {activeItem.name} →
              </Link>
            </div>
          )}
        </div>
      )}
    </Modal>
  );
};

TaxonomyModal.propTypes = {
  isOpen:     PropTypes.bool.isRequired,
  onClose:    PropTypes.func.isRequired,
  groups:     PropTypes.arrayOf(
    PropTypes.shape({
      id:          PropTypes.number,
      name:        PropTypes.string.isRequired,
      slug:        PropTypes.string.isRequired,
      description: PropTypes.string,
      items:       PropTypes.arrayOf(
        PropTypes.shape({
          id:           PropTypes.number,
          name:         PropTypes.string.isRequired,
          slug:         PropTypes.string.isRequired,
          icon:         PropTypes.node,
          color:        PropTypes.string,
          description:  PropTypes.string,
          hub_page_url: PropTypes.string,
        })
      ),
    })
  ),
  activeSlug: PropTypes.string,
};

TaxonomyModal.defaultProps = {
  groups:     [],
  activeSlug: null,
};

export default TaxonomyModal;